<div class="h-full overflow-hidden p-6 box-border">
  <div class="text-navy-600 font-semibold text-sm">Budget Line Breakdown</div>
  <div class="flex flex-col h-full w-full overflow-hidden">
    <ng-scrollbar appearance="compact" orientation="vertical" class="std-scrollbar">
      <div class="row header">
        <div class="ml-2"></div>
        <div class="uppercase item text-navy-500 font-bold text-size_xs text-center">Current<br />Budget</div>
        <div class="uppercase item text-navy-500 font-bold text-size_xs text-center">Prime<br />Contract</div>
        <div class="uppercase item text-navy-500 font-bold text-size_xs text-center">Committed<br />Costs</div>
        <div class="uppercase item text-navy-500 font-bold text-size_xs text-center">Prime Contract v<br />Budget</div>
        <div class="uppercase item text-navy-500 font-bold text-size_xs text-center">Committed v<br />Budget</div>
      </div>
      <div class="row">
        <span class="text-navy-900 font-bold text-size_xxl">
          {{ lineItem()?.name ?? 'Default Budget Line' }}
        </span>
        <span class="item text-navy-900 font-bold text-sm">
          <app-formatted-money [value]="lineItem()?.current_budget"></app-formatted-money
        ></span>
        <span class="item text-navy-900 font-bold text-sm">
          <app-formatted-money [value]="lineItem()?.prime_contract"></app-formatted-money
        ></span>
        <span class="item text-navy-900 font-bold text-sm">
          <app-formatted-money [value]="lineItem()?.committed_costs"></app-formatted-money>
        </span>
        <span class="item text-navy-900 font-bold text-sm">
          <app-formatted-money [value]="lineItem()?.prime_contract - lineItem()?.current_budget"></app-formatted-money>
        </span>
        <span class="item text-navy-900 font-bold text-sm">
          <app-formatted-money [value]="lineItem()?.committed_costs - lineItem()?.current_budget"></app-formatted-money>
        </span>
      </div>

      <div class="border-bottom"></div>

      @for (projectLineItem of lineItem()?.projects; track projectLineItem.id; let last = $last) {
        <div class="ml-2 row">
          <span
            (click)="navigateToProject(projectLineItem?.project_id)"
            class="text-navy-900 font-semibold text-size_xl cursor-pointer"
          >
            {{ projectLineItem?.project_title }}
          </span>
          <span class="item text-navy-900 font-semibold text-size_xl">
            <app-formatted-money [value]="projectLineItem?.current_budget"></app-formatted-money
          ></span>
          <span class="item text-navy-900 font-semibold text-size_xl">
            <app-formatted-money [value]="projectLineItem?.prime_contract"></app-formatted-money
          ></span>
          <span class="item text-navy-900 font-semibold text-size_xl">
            <app-formatted-money [value]="projectLineItem?.committed_costs"></app-formatted-money>
          </span>
          <span class="item text-navy-900 font-semibold text-size_xl">
            <app-formatted-money
              [value]="projectLineItem?.prime_contract - projectLineItem?.current_budget"
            ></app-formatted-money>
          </span>
          <span class="item text-navy-900 font-semibold text-size_xl">
            <app-formatted-money
              [value]="projectLineItem?.committed_costs - projectLineItem?.current_budget"
            ></app-formatted-money>
          </span>
        </div>
        @if (!last) {
          <div class="border-bottom"></div>
        }
      }
    </ng-scrollbar>
  </div>
</div>
